import React, {useState} from 'react';
import {Box, TextField, Typography, Autocomplete} from '@mui/material';
import COUNTRIES from '../../constants/countries';
import CustomButton from '../CustomButton';
import {useFormInput} from '../../utils/utilities';
import {useDispatch, useSelector} from 'react-redux';
import {addBuilding, editBuilding} from '../../actions';
import {fieldError, isFieldIvalid} from '../../utils/errorHandler';

const ComplexModal = ({edit}) => {
  const {modalProps} = useSelector(s => s.modal);
  const {buildingsLoading, buildingsError} = useSelector(s => s.buildings);
  const [country, setCountry] = useState(edit ? modalProps.country : '');
  const name = useFormInput(edit ? modalProps.name : '');
  const city = useFormInput(edit ? modalProps.city : '');
  const address = useFormInput(edit ? modalProps.address : '');
  const dispatch = useDispatch();

  const onSelectCountry = (_, newValue) => {
    setCountry(newValue);
  };

  const onInputCountry = (_, newValue) => {
    setCountry(newValue);
  };

  const onSubmit = e => {
    e.preventDefault();
    if (edit) {
      dispatch(
        editBuilding(
          name.value,
          city.value,
          country.label || country,
          address.value,
          modalProps.id,
        ),
      );
    } else {
      dispatch(
        addBuilding(
          name.value,
          city.value,
          country.label || country,
          address.value,
        ),
      );
    }
  };

  return (
    <>
      <Typography alignSelf="center" variant="h6" mt="1rem" fontWeight="bold">
        {edit ? 'Edit complex' : 'Add a new project'}
      </Typography>
      <form onSubmit={onSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          mt="2rem"
          gap="1rem"
          sx={{
            width: {xs: 'calc(100vw - 4rem)', sm: '30rem'},
          }}>
          <TextField
            {...name}
            required
            error={isFieldIvalid(buildingsError, 'name')}
            helperText={fieldError(buildingsError, 'name')}
            label="Project name"
          />
          <Box
            display="flex"
            gap="1rem"
            sx={{flexDirection: {xs: 'column', sm: 'row'}}}>
            <TextField
              {...city}
              error={isFieldIvalid(buildingsError, 'city')}
              helperText={fieldError(buildingsError, 'city')}
              required
              label="City"
              fullWidth
            />
            <Autocomplete
              freeSolo
              disablePortal
              id="combo-box-countries"
              options={COUNTRIES}
              value={country}
              onInputChange={onInputCountry}
              onChange={onSelectCountry}
              fullWidth
              renderInput={params => (
                <TextField
                  required
                  error={isFieldIvalid(buildingsError, 'country')}
                  helperText={fieldError(buildingsError, 'country')}
                  {...params}
                  label="Country"
                />
              )}
            />
          </Box>
          <TextField
            {...address}
            error={isFieldIvalid(buildingsError, 'address')}
            helperText={fieldError(buildingsError, 'address')}
            required
            label="Address"
          />
          <CustomButton type="submit" loading={buildingsLoading}>
            Submit
          </CustomButton>
        </Box>
      </form>
    </>
  );
};

export default ComplexModal;
